import React,{useState, useEffect,useContext} from "react";
import { useLocation } from 'react-router-dom'

import { AppContext } from "../../AppContext";

import HeaderComp from "./HeaderComp";
import SidebarComp from "./SidebarComp";
import FooterComp from "./FooterComp";

const LayoutComp = (props) => {
    
  const [appContext, setAppContext] = useContext(AppContext);
  const location = useLocation();
  const [collapsed,setCollapsed]  = useState(false);
  
  const toggleSidebar = ()=>{
    setCollapsed(p=>!p);
  };

  useEffect(() => {
    setAppContext({
      ...appContext,
      sidebarCollapsed: collapsed
    });
  }, [collapsed]);

  return (
    <div className="page-wrapper">      
      <HeaderComp toggleSidebar={toggleSidebar}/>
      {appContext.auth && (!(location.pathname==="/" || location.pathname==="/login")) && <SidebarComp collapsed={collapsed}/>}
      <div className="body-wrapper">{props.children}</div>
      <FooterComp />
    </div>
  );
};

export default LayoutComp;
